<template>
  <div class="root">
    <!-- nav section -->
    <NavBar />

    <router-view />
  </div>
</template>

<script>
import NavBar from "@/components/nav/NavBar";

export default {
  name: "Home",
  components: {
    NavBar,
  },
};
</script>

<style lang="scss" scoped>
</style>
